export const HomeSVG = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3 12.1835V13.5525C21.3 17.0632 21.3 18.8187 20.2456 19.9093C19.1913 21 17.4941 21 14.1 21H10.5C7.10593 21 5.40888 21 4.35446 19.9093C3.30005 18.8187 3.30005 17.0632 3.30005 13.5525V12.1835C3.30005 10.1239 3.30005 9.09415 3.76733 8.24047C4.23461 7.38679 5.0883 6.85696 6.79568 5.79732L8.59568 4.68018C10.4005 3.56006 11.3029 3 12.3 3C13.2972 3 14.1996 3.56006 16.0044 4.68018L17.8044 5.79731C19.5118 6.85696 20.3655 7.38679 20.8328 8.24047"
        stroke="#676A79"
        stroke-linecap="round"
      />
      <path d="M15.3 18H9.30005" stroke="#676A79" stroke-linecap="round" />
    </svg>
  );
};

export const HomeFillSVG = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.3 12.2039V13.725C22.3 17.6258 22.3 19.5763 21.1284 20.7881C19.9569 22 18.0712 22 14.3 22H10.3C6.52881 22 4.6432 22 3.47162 20.7881C2.30005 19.5763 2.30005 17.6258 2.30005 13.725V12.2039C2.30005 9.91549 2.30005 8.77128 2.81925 7.82274C3.33845 6.87421 4.287 6.28551 6.18408 5.10813L8.18408 3.86687C10.1894 2.62229 11.1921 2 12.3 2C13.4079 2 14.4106 2.62229 16.416 3.86687L18.416 5.10812C20.3131 6.28551 21.2616 6.87421 21.7808 7.82274"
        fill="#005FDA"
      />
      <path
        d="M22.3 12.2039V13.725C22.3 17.6258 22.3 19.5763 21.1284 20.7881C19.9569 22 18.0712 22 14.3 22H10.3C6.52881 22 4.6432 22 3.47162 20.7881C2.30005 19.5763 2.30005 17.6258 2.30005 13.725V12.2039C2.30005 9.91549 2.30005 8.77128 2.81925 7.82274C3.33845 6.87421 4.287 6.28551 6.18408 5.10813L8.18408 3.86687C10.1894 2.62229 11.1921 2 12.3 2C13.4079 2 14.4106 2.62229 16.416 3.86687L18.416 5.10812C20.3131 6.28551 21.2616 6.87421 21.7808 7.82274"
        stroke="#005FDA"
        stroke-linecap="round"
      />
      <path
        d="M15.3 18H9.30005"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default HomeFillSVG;
export const FavSVG = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1692 4.41115C12.4007 3.89177 12.5165 3.63208 12.6777 3.55211C12.8177 3.48263 12.9821 3.48263 13.1221 3.55211C13.2833 3.63208 13.3991 3.89177 13.6306 4.41115L15.4746 8.54808C15.5431 8.70162 15.5773 8.77839 15.6303 8.83718C15.6771 8.8892 15.7344 8.93081 15.7983 8.95929C15.8706 8.99149 15.9542 9.00031 16.1214 9.01795L20.6257 9.49336C21.1912 9.55304 21.4739 9.58288 21.5998 9.71147C21.7091 9.82316 21.7599 9.97956 21.7371 10.1342C21.7109 10.3122 21.4997 10.5025 21.0773 10.8832L17.7126 13.9154C17.5878 14.0279 17.5253 14.0842 17.4858 14.1527C17.4508 14.2134 17.4289 14.2807 17.4216 14.3503C17.4133 14.429 17.4307 14.5112 17.4656 14.6757L18.4054 19.1064C18.5234 19.6627 18.5824 19.9408 18.499 20.1002C18.4265 20.2388 18.2935 20.3354 18.1394 20.3615C17.962 20.3915 17.7157 20.2495 17.2231 19.9654L13.2996 17.7024C13.154 17.6184 13.0812 17.5765 13.0038 17.56C12.9353 17.5455 12.8645 17.5455 12.796 17.56C12.7186 17.5765 12.6458 17.6184 12.5002 17.7024L8.57677 19.9654C8.08419 20.2495 7.8379 20.3915 7.66049 20.3615C7.50638 20.3354 7.37334 20.2388 7.3009 20.1002C7.21751 19.9408 7.2765 19.6627 7.39449 19.1064L8.33425 14.6757C8.36913 14.5112 8.38657 14.429 8.37829 14.3503C8.37096 14.2807 8.34909 14.2134 8.31409 14.1527C8.27454 14.0842 8.2121 14.0279 8.08723 13.9154L4.72261 10.8832C4.3002 10.5025 4.08899 10.3122 4.06273 10.1342C4.03993 9.97956 4.09074 9.82316 4.20008 9.71147C4.32596 9.58288 4.60871 9.55304 5.17421 9.49336L9.6785 9.01795C9.84568 9.00031 9.92926 8.99149 10.0015 8.95929C10.0655 8.93081 10.1227 8.8892 10.1696 8.83718C10.2226 8.77839 10.2568 8.70162 10.3252 8.54808L12.1692 4.41115Z"
        stroke="#676A79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FavFillSVG = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1692 4.41115C12.4007 3.89177 12.5165 3.63208 12.6777 3.55211C12.8177 3.48263 12.9821 3.48263 13.1221 3.55211C13.2833 3.63208 13.3991 3.89177 13.6306 4.41115L15.4746 8.54808C15.5431 8.70162 15.5773 8.77839 15.6303 8.83718C15.6771 8.8892 15.7344 8.93081 15.7983 8.95929C15.8706 8.99149 15.9542 9.00031 16.1214 9.01795L20.6257 9.49336C21.1912 9.55304 21.4739 9.58288 21.5998 9.71147C21.7091 9.82316 21.7599 9.97956 21.7371 10.1342C21.7109 10.3122 21.4997 10.5025 21.0773 10.8832L17.7126 13.9154C17.5878 14.0279 17.5253 14.0842 17.4858 14.1527C17.4508 14.2134 17.4289 14.2807 17.4216 14.3503C17.4133 14.429 17.4307 14.5112 17.4656 14.6757L18.4054 19.1064C18.5234 19.6627 18.5824 19.9408 18.499 20.1002C18.4265 20.2388 18.2935 20.3354 18.1394 20.3615C17.962 20.3915 17.7157 20.2495 17.2231 19.9654L13.2996 17.7024C13.154 17.6184 13.0812 17.5765 13.0038 17.56C12.9353 17.5455 12.8645 17.5455 12.796 17.56C12.7186 17.5765 12.6458 17.6184 12.5002 17.7024L8.57677 19.9654C8.08419 20.2495 7.8379 20.3915 7.66049 20.3615C7.50638 20.3354 7.37334 20.2388 7.3009 20.1002C7.21751 19.9408 7.2765 19.6627 7.39449 19.1064L8.33425 14.6757C8.36913 14.5112 8.38657 14.429 8.37829 14.3503C8.37096 14.2807 8.34909 14.2134 8.31409 14.1527C8.27454 14.0842 8.2121 14.0279 8.08723 13.9154L4.72261 10.8832C4.3002 10.5025 4.08899 10.3122 4.06273 10.1342C4.03993 9.97956 4.09074 9.82316 4.20008 9.71147C4.32596 9.58288 4.60871 9.55304 5.17421 9.49336L9.6785 9.01795C9.84568 9.00031 9.92926 8.99149 10.0015 8.95929C10.0655 8.93081 10.1227 8.8892 10.1696 8.83718C10.2226 8.77839 10.2568 8.70162 10.3252 8.54808L12.1692 4.41115Z"
        fill="#005FDA"
        stroke="#005FDA"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ListSVG = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8768 7.08679V18.3621C19.8768 19.8013 18.8503 20.4067 17.5968 19.712L13.7178 17.5383C13.3033 17.31 12.6321 17.31 12.2175 17.5383L8.33859 19.712C7.08509 20.4067 6.05859 19.8013 6.05859 18.3621V7.08679C6.05859 5.38955 7.4404 4 9.12819 4H16.8072C18.495 4 19.8768 5.38955 19.8768 7.08679Z"
        stroke="#676A79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ListFillSVG = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8768 7.08679V18.3621C19.8768 19.8013 18.8503 20.4067 17.5968 19.712L13.7178 17.5383C13.3033 17.31 12.6321 17.31 12.2175 17.5383L8.33859 19.712C7.08509 20.4067 6.05859 19.8013 6.05859 18.3621V7.08679C6.05859 5.38955 7.4404 4 9.12819 4H16.8072C18.495 4 19.8768 5.38955 19.8768 7.08679Z"
        fill="#005FDA"
      />
    </svg>
  );
};

export const ChatSVG = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8501 5.13715C15.5998 4.41392 14.1483 4 12.6001 4C7.90568 4 4.1001 7.80558 4.1001 12.5C4.1001 13.8597 4.41937 15.1449 4.98704 16.2846C5.1379 16.5875 5.18811 16.9337 5.10065 17.2605L4.59438 19.1527C4.37461 19.9741 5.12606 20.7255 5.94745 20.5057L7.83958 19.9995C8.16644 19.912 8.51263 19.9622 8.8155 20.113C9.95521 20.6807 11.2404 21 12.6001 21C17.2945 21 21.1001 17.1944 21.1001 12.5C21.1001 10.9518 20.6861 9.50024 19.963 8.25"
        stroke="#676A79"
        stroke-linecap="round"
      />
      <path
        d="M9.1001 12.6572H9.1091M13.0911 12.6572H13.1001M17.0911 12.6572H17.1001"
        stroke="#676A79"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ChatFillSVG = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8501 5.13715C15.5998 4.41392 14.1483 4 12.6001 4C7.90568 4 4.1001 7.80558 4.1001 12.5C4.1001 13.8597 4.41937 15.1449 4.98704 16.2846C5.1379 16.5875 5.18811 16.9337 5.10065 17.2605L4.59438 19.1527C4.37461 19.9741 5.12606 20.7255 5.94745 20.5057L7.83958 19.9995C8.16644 19.912 8.51263 19.9622 8.8155 20.113C9.95521 20.6807 11.2404 21 12.6001 21C17.2945 21 21.1001 17.1944 21.1001 12.5C21.1001 10.9518 20.6861 9.50024 19.963 8.25"
        fill="#005FDA"
      />
      <path
        d="M16.8501 5.13715C15.5998 4.41392 14.1483 4 12.6001 4C7.90568 4 4.1001 7.80558 4.1001 12.5C4.1001 13.8597 4.41937 15.1449 4.98704 16.2846C5.1379 16.5875 5.18811 16.9337 5.10065 17.2605L4.59438 19.1527C4.37461 19.9741 5.12606 20.7255 5.94745 20.5057L7.83958 19.9995C8.16644 19.912 8.51263 19.9622 8.8155 20.113C9.95521 20.6807 11.2404 21 12.6001 21C17.2945 21 21.1001 17.1944 21.1001 12.5C21.1001 10.9518 20.6861 9.50024 19.963 8.25"
        stroke="#005FDA"
        stroke-linecap="round"
      />
      <path
        d="M9.1001 12.6572H9.1091M13.0911 12.6572H13.1001M17.0911 12.6572H17.1001"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
